import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { FunctionComponent } from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

/* Custom Code */
import InfosBox, { InfosBoxProps } from "@store/Library/Components/Toolkit/InfosBox";
/* Custom Code */

const mapStateToProps = (state: ApplicationState) => ({
    cart: getCurrentCartState(state).value,
});

export interface CartApproverMessageStyles {
    approvingText?: TypographyPresentationProps;
    approvingWrapper?: InjectableCss;
    // Custom Code
    infosBox?: InfosBoxProps;
}

export const cartApproverMessageStyles: CartApproverMessageStyles = {
    infosBox: {},
};

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

const styles = cartApproverMessageStyles;
const CartApproverMessage = ({ cart }: Props) => {
    if (!cart || !cart.isAwaitingApproval || cart.cartLines?.length === 0) {
        return null;
    }

    /* Custom Code */
    return (
        <InfosBox {...styles.infosBox} data-test-selector="cart_approvingOrderMessage">
            {translate("Approving Order for {0}", cart.initiatedByUserName?.toUpperCase())}
        </InfosBox>
    );
    /* Custom Code */
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(CartApproverMessage),
    definition: {
        displayName: "Cart Approver Message",
        icon: "cart-circle-check",
        group: "Common",
    },
};

export default widgetModule;
